import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";

import axios from "axios";
import { toast } from "react-toastify";
import FormDialog from "./form";
import AssignCompany from "./assignCompany";
import ButtonComponent from "components/button";
import { useApiClient } from "context/ApiClientContext";
import ErrorAlert from "helper/errorAlert";
import { useNavigate } from "react-router-dom";

function UserSetting({ userData, userId, handleShowForm }) {
  const [mode, setMode] = useState();
  const [open, setOpen] = React.useState(false);
  const [errors, setErrors] = useState({});
  
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const [inputForm, setInputForm] = useState(
    userData || {
      userName: "",
      email: "",
      password: "",
      // oldPassword: "",
      isActive: true,
      lastcompany: 0,
      roleid: "2",
      bulkcompanyuser: [],
    }
  );
  const apiClient = useApiClient();
  const validate = (name, value) => {
    switch (name) {
      case "userName":
        if (!value.trim()) return "Username is required";
        return "";
      case "email":
        if (!value.trim()) return "Email is required";
        if (!/\S+@\S+\.\S+/.test(value)) return "Email is invalid";
        return "";
      case "password":
        if (!value) return "Password is required";
        return "";
      default:
        return "";
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!inputForm.userName) newErrors.userName = "Username is required";
    if (!inputForm.email) newErrors.email = "Email is required";
    if (!inputForm.password) newErrors.password = "Password is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (userId) {
      setMode("edit");
    } else {
      setMode("create");
    }
  }, [userId]);

  const updateConfig = async () => {
    // try {
    if (validateForm()) {
      // if (selectedCompany) {
      //   inputForm.bulkcompanyuser = selectedCompany;
      // }
      // if (inputForm.oldPassword == null) {
      //   inputForm.oldPassword = "";
      // }
      if (!inputForm.lastcompany) {
        toast.error("One default company is required", {
          position: "top-right",
        });
        return;
      }

      handleOpen();
      const toastId = toast.loading('Saving data...', {
        position: 'top-right',
        autoClose: 3000,
      });
      try {
        await new Promise(resolve => setTimeout(resolve, 3000));

        let response = '';
        if (mode === "create") {
          response = await axios.post(
            `${apiClient}/user`,
            inputForm,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                Accept: "application/json",
              },
            }
          );
        } else {
          response = await axios.put(
            `${apiClient}/user/${userId}`,
            inputForm,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                Accept: "application/json",
              },
            }
          );
        }

        toast.update(toastId, {
          render: mode === 'create' ? 'Successfully created.' : 'Successfully updated.',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        });

        setTimeout(() => {
          handleShowForm();
        }, 500);

      } catch (error) {
        ErrorAlert(error, navigate);

        toast.update(toastId, {
          render: '',
          isLoading: false,
          autoClose: 1,
        });
      } finally {
        // setTimeout(() => {
        handleClose();
        // }, 1000);
      }
    }
  };
  //   } catch (error) {

  //     handleClose();
  //     if (error?.response?.data?.errors) {
  //       const errorList = error.response.data.errors;
  //       for (const key in errorList) {
  //         if (errorList.hasOwnProperty(key)) {
  //           errorList[key].forEach((message) => {
  //             toast.error(message, {
  //               position: "top-right",
  //             });
  //           });
  //         }
  //       }
  //     }
  //     else {
  //       toast.error(error.response.data, {
  //         position: "top-right",
  //       });
  //     }
  //   }
  // };

  const handleInputChange = (property, value) => {
    setInputForm((prevState) => ({
      ...prevState,
      [property]: value,
    }));

    const error = validate(property, value);
    setErrors({ ...errors, [property]: error });

  };
  return (
    <Grid
      container
      spacing={5}
      bgcolor=""
      mt={1}
      display="flex"
      justifyContent="center"
    >
      <Grid item xs={12} lg={8}>
        <div>
          <FormDialog
            id={userId}
            mode={mode}
            errors={errors}
            inputForm={inputForm}
            handleInputChange={handleInputChange}
            handleShowForm={handleShowForm}
          />
        </div>
      </Grid>
      <Grid item xs={12} lg={8}>
        <div>
          <AssignCompany
            errors={errors}
            userId={userId}
            open={open}
            inputForm={inputForm}
            handleInputChange={handleInputChange}
          />
        </div>
      </Grid>
      {/* <Grid item xs={12} lg={8}>
        <div>
          <ConsolidatedInvoice
            apiSetting={dataList || {}}
            updateApiSetting={updateApiSettingFromChild}
          />
          <CompanyList
            open={open}
            userId={userId}
            mode={mode}
            inputForm={inputForm}
            callbackSetSelectedRows={setSelectedRows}
            handleInputChange={handleInputChange}
          />
        </div>
      </Grid> */}

      <Grid item xs={12} lg={8} display="flex" justifyContent="end">
        <ButtonComponent value="contained" text="Save" callback={updateConfig} />
      </Grid>
    </Grid>
  );
}

export default UserSetting;
